import { Box, Circle, Cone, Cylinder, Square, type LucideIcon } from "lucide-react"
import type { ScenePrimitiveShape } from "@/lib/location-scene-3d/scene-state"

/** Cylinder first — historical default icon on the shapes toolbar button. */
export const SCENE_PRIMITIVE_SHAPES: { shape: ScenePrimitiveShape; icon: LucideIcon }[] = [
  { shape: "cylinder", icon: Cylinder },
  { shape: "box", icon: Box },
  { shape: "sphere", icon: Circle },
  { shape: "cone", icon: Cone },
  { shape: "plane", icon: Square },
]
